<div class="container">
  <jmkw-checkboxes
    [checkboxNodeMap]="(checkboxNodeMap$ | async)!"
    (flatChange)="onChange($event)"
    [automationKey]="automationKey"
  ></jmkw-checkboxes>
</div>
